import React, { FC } from 'react'

import { DemoPopup } from 'pages/soundscape-page/components/DemoPopup'

import bg from './assets/voice-bg.jpg'
import mobileBg from './assets/voice-bg-mobile.jpg'

import type { SoundscapeDemoPopupContent } from 'redux/popupReducer'

interface SoundscapeVoiceProps {
  content: SoundscapeDemoPopupContent
}

export const SoundscapeVoice: FC<SoundscapeVoiceProps> = ({ content }) => {
  return (
    <DemoPopup
      backgroundImage={bg}
      mobileBackgroundImage={mobileBg}
      logo={content.logoUrl}
      title={content.title}
      description={content.description}
    />
  )
}
